<div class="modal right" id="uberMenuCategory" tabindex="-1" role="dialog" aria-labelledby="uberMenuCategoryLabel">
    <div class="modal-dialog" role="document">
        <div class="modal-content" id="print-content">
            <div class="modal-header hide-print">
                <div class="modal-title">
					<h4 id="uberMenuCategoryLabel" ng-if="modalType === 'new_category'">New Category</h4>
                    <h4 id="uberMenuCategoryLabel" ng-if="modalType === 'edit_category'">Edit Category</h4>
                </div>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <i class="icon-close-circle"></i>
                </button>
            </div>
            <div class="modal-body order-detail-page">
                <div class="modal-body-container">
					<div class="tab-content">
						<div class="tab-pane active">
							<div class="row">
								<div class="col-md-12">
									<form ng-submit="saveCategory(selectedCategory)" class="form-horizontal allcp-form" autocomplete="off">
										<h4 style="font-size:13px">Category Info</h4>
										<div class="row">
											<div class="col-md-12 pl15">
												<div class="form-group floating">
													<input type="text" ng-model="selectedCategory.title.translations.en" class="form-control input-md" placeholder="Name" required>
													<label>Name</label>
												</div>
											</div>
										</div>

										<div class="form-group floating">
											<label>Items : </label>
											<ui-select 
												multiple 
												ng-model="selectedData.category_items"
												theme="bootstrap" 
												sortable="true" 
												class="gui-input br-light light" 
												style="width: 100%;"
												title="Items">
												<ui-select-match placeholder="Items...">{{$item.title.translations.en}}</ui-select-match>
												<ui-select-choices repeat="item.id as item in data.menu.items | filter:$select.search | orderBy: 'title.translations.en'">
													{{item.title.translations.en}}
												</ui-select-choices>
											</ui-select>
										</div>

										<div ui-sortable="sortableOptions" ng-model="selectedData.category_items">
											<div class="row m5" ng-repeat="item in selectedData.category_items">
												<div class="col-md-12 work-steps">
													<a href="#" class="mr10 ml10">
														<i class="fa fa-bars"></i>
													</a>
													<strong>{{ $index+1 }} - {{ item.title.translations.en }}</strong>
													<!-- <a href="#" style="color:#8da2b3" ng-click="deleteStep(item.id,'set')"> Remove</a> -->
												</div>
											</div>
										</div>

										<div class="form-group floating pln">
											<div class="col-md-12 pln">
												<button type="submit" class="hod-button blue" ng-disabled="loading">
													<span ng-if="modalType === 'new_category'">CREATE</span>
                    								<span ng-if="modalType === 'edit_category'">UPDATE</span>
												</a>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
            </div>
        </div>
    </div>
</div>
